import { logEvent } from './logGaEvent'

const getPage = () => (typeof window === 'undefined' ? '' : window.PCLN_BOOTSTRAP_DATA?.page)

const logSetiFireImpression = (setiName, setiDetails) => {
  const attributes = {
    seti_id: setiDetails?.setiID,
    seti_variant_id: setiDetails?.setiVariantID,
    seti_name: setiName,
    page_name: getPage(),
    product_name: 'air',
    platform_name: '', //Leaving blank for now
  }
  logEvent('seti', attributes)
}

const logAllSetiImpressions = (seti = {}) => {
  Object.keys(seti).forEach((setiName) => {
    logSetiFireImpression(setiName, seti[setiName])
  })
}

export { logAllSetiImpressions }
